export default {
    type: 'set',
    format: {},
    default: {
        logic: 'match',
        tolerance: 2,
        operand: '>=',
        value: []
    },
    setting: {
        logic: ['match', 'oneof', 'someof', 'allof']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Languages',
        category: 'Game',
        description: 'Languages included in or required to play the game.',
        summarise: {
            prefix: 'Language'
        },
        unit: 'language'
    },
    rules: {
        linked: [],
        legacy: ['languages']
    }
}